import { useMemo, useState, type ReactNode } from 'react'

type AuthLogoImageProps = {
  sources: Array<string | null | undefined>
  alt: string
  className: string
  fallback: ReactNode
}

export function AuthLogoImage({ sources, alt, className, fallback }: AuthLogoImageProps) {
  const resolvedSources = useMemo(
    () => sources.map((source) => String(source ?? '').trim()).filter(Boolean),
    [sources],
  )
  const [sourceIndex, setSourceIndex] = useState(0)
  const src = resolvedSources[sourceIndex]

  if (!src) {
    return <>{fallback}</>
  }

  return (
    <img
      src={src}
      alt={alt}
      className={className}
      onError={() => {
        setSourceIndex((current) => current + 1)
      }}
    />
  )
}
